import DatasharePage from "@/components/products/datashare/DatasharePage"

type Props = {}

const index = (_props: Props) => {
  return <DatasharePage />
}

export default index
